var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-white pt-6 px-8" },
    [
      _c(
        "div",
        { staticClass: "flex flex-col gap-4" },
        [
          _c("div", [
            _c("p", { staticClass: "font-outfit font-normal text-lg" }, [
              _vm._v("Notes "),
              _c("span", { staticClass: "text-gray-new" }, [
                _vm._v("(" + _vm._s(this.paginationConfig.total) + ")"),
              ]),
            ]),
          ]),
          _c("NotesCollectionFilters", {
            attrs: {
              currentUserId: _vm.currentUser.id,
              filters: _vm.directoryFilters,
              filterClass: "w-max-content",
            },
            on: {
              filtersChanged: _vm.updateFilters,
              resetFilters: _vm.resetFilters,
            },
          }),
          _vm.empty
            ? _c("EmptyListPlaceholder", {
                attrs: { title: _vm.emptyListMessage },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "image",
                      fn: function () {
                        return [_c("EmptyListImageManagers")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  2783177247
                ),
              })
            : _vm._e(),
          _vm._l(_vm.notes, function (note) {
            return _c("NotesCard", {
              key: note.id,
              attrs: { currentUser: _vm.currentUser, note: note },
            })
          }),
        ],
        2
      ),
      _c("CardPagination", {
        attrs: { config: _vm.paginationConfig },
        on: {
          "update:config": function ($event) {
            _vm.paginationConfig = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }